import React, { Component } from 'react'
import '../css/dashboard.css'
import Header from './Header'
import Sidebar from './Sidebar';
import Footer from './Footer';
import CustomerTableRows from './CustomerTableRows'
import { Modal, Button } from 'react-bootstrap'

export class Customers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            customers : [],
            isLoading : true,
            showModal : false
        }
        this.handleShowModal = this.handleShowModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
    }

    componentDidMount() {
        fetch("http://localhost/lmt/api/customer")
        .then(response => response.json())
        .then(result => this.setState({customers: result.data, isLoading: false}))
    }

    handleShowModal() {
        this.setState({ showModal: true })
        window.FB.getLoginStatus(function(response) {
            if (response.status === 'connected') {
                console.log(response.authResponse.accessToken);
            }
        });
    }

    handleCloseModal() {
        this.setState({ showModal: false })
    }

    render() {
        return (
            <div>
                <Header />
                <div className="container-fluid">
                    <div className="row">
                        <Sidebar active="/customers" />
                        <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                                <h1 className="h2">Customers</h1>
                                <div className="btn-toolbar mb-2 mb-md-0">
                                    <button type="button" className="btn btn-primary" onClick={this.handleShowModal} title="Add New Customer">
                                        Add&nbsp;&nbsp;
                                        <i className="fas fa-plus-circle"></i>
                                    </button>
                                </div>
                            </div>
                            <div className="input-group mb-3 ml-auto mr-0" style={{width: "20%"}}>
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-search"></i></span>
                                </div>
                                <input type="search" className="form-control" placeholder="Search Query" aria-describedby="basic-addon1" />
                            </div>
                            <table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>API URL</th>
                                        <th>FB Page Id</th>
                                        <th>FB Page Name</th>
                                        <th>Status</th>
                                        <th>Created At</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.isLoading ?
                                    <tr><td colSpan="8" className="text-center my-3"><i className="fas fa-spinner fa-spinner-animate"></i></td></tr> :
                                    <CustomerTableRows rows={this.state.customers} />
                                }
                                </tbody>
                            </table>
                        </main>
                    </div>
                </div>
                <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Modal heading</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleCloseModal} title="Save Customer Details">
                            Save&nbsp;&nbsp;
                            <i className="fas fa-save"></i>
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Footer />
            </div>
        )
    }
}

export default Customers
